// react
import { Map } from "immutable";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// portals
import PeopleCustomField from "./portals/PeopleCustomField";

const elementIDs = [];
const currentPeopleArray = [];
const currentFieldsArray = [];
const currentPermissionArray = [];

const parseStringRepOfPeopleArray = (stringRep) => {
	try {
		const validJSON = stringRep.replace(/'/g, '"');
		const addBackApostrophes = validJSON.replaceAll("&apos;", "'");
		const parsedData = JSON.parse(addBackApostrophes);
		const [peopleData, permissionData, fieldData] = parsedData;
		// don't alphabetize if field is contributors (PY-1926 PY-4252)
		const alphabetize = fieldData.name.toLowerCase() !== "contributors";
		if (alphabetize) {
			// sort peopleData by name
			peopleData.sort((a, b) => (a.name > b.name ? 1 : -1));
		}
		return { peopleData, permissionData, fieldData };
	} catch (err) {
		return { peopleData: [], permissionData: {} };
	}
};

const selectPermissions = (permissionData) => {
	const { edit = [], visibility = [], permission = [] } = permissionData;
	const canEdit = permission.some((editPermission) => edit.includes(editPermission));
	const canView = permission.some((editPermission) => visibility.includes(editPermission));

	return { canEdit, canView };
};

/**
 * Creates an array of Maps, expected by PeopleCustomField
 * @param {array} peopleData: array of sorted data on current people field value
 */
const createPeopleMap = (peopleData) => {
	let peopleArray = [];
	try {
		peopleData.forEach((person) => {
			const { id = null, name = null } = person;
			if (id && name) {
				const peopleMap = Map({ id, name });
				peopleMap.set("id", id);
				peopleMap.set("name", name);

				peopleArray.push(peopleMap);
			}
		});
	} catch (err) {
		peopleArray = [];
	}

	return peopleArray;
};

function EditEmployee() {
	const [currentPeopleValue, setCurrentPeopleValue] = useState(0);
	const [currentPermissionData, setCurrentPermissonData] = useState(0);
	const [currentFieldsData, setCurrentFieldData] = useState();
	const { userID = "" } = useParams();

	useEffect(() => {
		// get all people input fields
		const form = document.getElementsByClassName("people-custom-field");

		// add each input's unique id into elementIDs
		for (let i = 0; i < form.length; i += 1) {
			elementIDs[i] = form[i].getAttribute("id");

			const rawData = form[i].getAttribute("data");
			const parsedData = parseStringRepOfPeopleArray(rawData);
			const peopleMap = createPeopleMap(parsedData.peopleData);
			const { canEdit, canView } = selectPermissions(parsedData.permissionData);

			currentPeopleArray[i] = peopleMap;
			currentPermissionArray[i] = { canEdit, canView };
			currentFieldsArray[i] = parsedData.fieldData;
		}

		setCurrentPeopleValue(currentPeopleArray);
		setCurrentPermissonData(currentPermissionArray);
		setCurrentFieldData(currentFieldsArray);
	}, []);

	return (
		<>
			{elementIDs.map((elementID, idx) => (
				<PeopleCustomField
					key={elementID}
					elementID={elementID}
					currentPeopleArray={currentPeopleValue[idx]}
					currentPermissionData={currentPermissionData[idx]}
					currentFieldsData={currentFieldsData[idx]}
					currentUserID={userID}
				/>
			))}
		</>
	);
}

export default EditEmployee;
